import { render, staticRenderFns } from "./ReplacementsMars.vue?vue&type=template&id=183b11d8&scoped=true&"
import script from "./ReplacementsMars.vue?vue&type=script&lang=js&"
export * from "./ReplacementsMars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b11d8",
  null
  
)

export default component.exports